import { z } from 'zod';

export type TeamId = Team['id'];

export type Team = z.output<typeof teamSchema>;
export type TeamDTO = z.input<typeof teamSchema>;

export const teamSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  imageUrl: z.string().nullable(),
  playerIds: z.array(z.uuid()),
});
